import type { MisureFotovoltaicoDTO } from '@/models/dto/fotovoltaico/misure-fotovoltaico-dto'
import type { PhotovoltaicReading } from '@/models/types/photovoltaic/photovoltaic-reading'

function mapToMisureFotovoltaicoDTO(reading: PhotovoltaicReading): MisureFotovoltaicoDTO {
    return {
        ts: reading.timestamp,
        v: reading.value,
        um: reading.uom ?? null,
        id: reading.id 

    }
}

function mapToPhotovoltaicReading(dto: MisureFotovoltaicoDTO): PhotovoltaicReading {
    return {
        timestamp: dto.ts,
        value: dto.v,
        uom: dto.um ?? undefined,
        id : dto.id 
    }
}

export { mapToMisureFotovoltaicoDTO, mapToPhotovoltaicReading }
